export const mdFix = (str: string): string => {
  return str.replace(/```python3\n/g, "```python\n");
};
